import { MutableRefObject, useEffect, useRef, useState } from 'react';

type hookType = {
  isIntersecting: boolean;
  setIntersectingFalse: () => void;
};

const useIntersectionObserver = (
  ref: MutableRefObject<Element | null>,
  forward = false,
): hookType => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [tagElement, setTagElement] = useState<Element | null>(null);
  const observer = useRef<null | IntersectionObserver>(null);

  useEffect(() => {
    setTagElement(ref.current);
  }, [ref]);

  const disconnect = () => {
    if (observer.current) observer.current.disconnect();
  };

  const setIntersectingFalse = () => {
    setIsIntersecting(false);
  };

  useEffect(() => {
    if (tagElement) {
      disconnect();

      const ob = (observer.current = new IntersectionObserver(entry => {
        if (!forward) {
          setIsIntersecting(entry[0].isIntersecting);
        } else if (forward && !isIntersecting && entry[0].isIntersecting) {
          setIsIntersecting(entry[0].isIntersecting);
          disconnect();
        }
      }));

      ob.observe(tagElement);

      return () => {
        disconnect();
      };
    }
  }, [tagElement]);

  return { isIntersecting, setIntersectingFalse };
};

export default useIntersectionObserver;
